import { TTranslateFunction } from '@modules/localization/types/TranslateFunction';
import { OpenAPI } from '@rbx/docsite-utilities/dist/browser';

export default function getRateLimitMarkdown(
  translate: TTranslateFunction,
  rateLimits: OpenAPI.OperationObject['x-roblox-rate-limits'],
) {
  if (!rateLimits) {
    return '';
  }

  /**
   * - **API key**: 60 requests per minute across all API keys for a user or group
   * - **OAuth 2.0**: 10 requests per minute per access token
   *
   * A custom description.
   *
   * Note: Rate limits can be lower during high-traffic periods. Certain endpoints have additional rate limits. [Learn more about rate limits](../limits).
   */

  const items = [
    rateLimits.perApiKeyOwner
      ? `- **${translate(`Label.ApiKey`)}**: ${translate(
          `Description.RateLimits.APIKey.${rateLimits.perApiKeyOwner.period}`,
          {
            limit: rateLimits.perApiKeyOwner.maxInPeriod?.toString() ?? '',
          },
        )}`
      : '',
    rateLimits.perOauth2Authorization
      ? `- **${translate(`Label.OAuth2`)}**: ${translate(
          `Description.RateLimits.OAuth2.${rateLimits.perOauth2Authorization.period}`,
          {
            limit: rateLimits.perOauth2Authorization.maxInPeriod?.toString() ?? '',
          },
        )}`
      : '',
    rateLimits.description ? `\n${rateLimits.description}` : '',
    `\n${translate('Description.RateLimitAsGuideline', {
      link: '/cloud/reference/rate-limits',
    })}`,
  ].filter(Boolean);

  return items.join('\n');
}
